import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { availableZipCodes } from '@mwe/models';

export function zipCodeValidator(ignoreValidation: boolean): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control?.value?.trim?.();

    if (ignoreValidation || !value || value?.length < 4) {
      return null;
    }

    if (availableZipCodes.includes(value)) {
      return null;
    }

    return { zipAvailability: true };
  };
}
